import React, { useState } from "react";
import "./Navbar.css";
import {Link} from 'react-router-dom'

const Mobile = () => {
    const [isOpen, setIsOpen] = useState(false);
  const [openMenus, setOpenMenus] = useState({}); // track multiple open submenus

  const toggleMenu = () => setIsOpen(!isOpen);

  const toggleSubMenu = (id) => {
    setOpenMenus((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  return (
    <div>
      <button className="menu-button" onClick={toggleMenu}>
        <i class="mobile-nav-toggle d-xl-none bi bi-list" aria-controls="navmenu"></i>
      </button>

      <nav className={`mobile-menu ${isOpen ? "open" : ""}`}>
        <button className="close-button" onClick={toggleMenu}>
          ✕
        </button>

        <ul>

        <li className="has-submenu" id="main-nav">
            <span>Takshila VLS</span>
            <i
              className={`bi toggle-dropdown ${
                openMenus["takshila"] ? "bi-chevron-up" : "bi-chevron-down"
              }`}
              onClick={() => toggleSubMenu("takshila")}
            ></i>
            <ul className={`sub-menu ${openMenus["takshila"] ? "open" : ""}`}>
              <li><a href='#'>About Us</a></li>
                      <li><a href='#'>Vision</a></li>
                      <li><a href='#'>Why Join Us</a></li>
                      <li><a href='#'>Blog</a></li>
                      <li><a href='#'>Apply as Trainer</a></li>
            </ul>
          </li>

          <li className="has-submenu" id="main-nav">
            <span>Courses</span>
            <i
              className={`bi toggle-dropdown ${
                openMenus["course"] ? "bi-chevron-up" : "bi-chevron-down"
              }`}
              onClick={() => toggleSubMenu("course")}
            ></i>
            <ul className={`sub-menu ${openMenus["course"] ? "open" : ""}`} id="sub-nav">

              <li className="has-submenu">
                <span>For Freshers</span>
                <i
                  className={`bi toggle-dropdown ${
                    openMenus["freshers"] ? "bi-chevron-up" : "bi-chevron-down"
                  }`}
                  onClick={() => toggleSubMenu("freshers")}
                ></i>
                <ul className={`sub-menu ${openMenus["freshers"] ? "open" : ""}`} id="sub-sub-nav">
                  <li><a href='#'>Physical Design</a></li>
                  <li><a href="#">ASIC Verification</a></li>
                  <li><a href="#">Analog Layout Design</a></li>
                  <li><a href="#">Design For Test</a></li>
                  <li><a href="#">Analog Circuit Design</a></li>
                  <li><a href="#">RTL Coding and FPGA Design</a></li>
                  <li><a href="#">Embedded Systems Training</a></li>
                </ul>
              </li>
              <li className="has-submenu">
                <span>For Working Professionals</span>
                <i
                  className={`bi toggle-dropdown ${
                    openMenus["profess"] ? "bi-chevron-up" : "bi-chevron-down"
                  }`}
                  onClick={() => toggleSubMenu("profess")}
                ></i>
                <ul className={`sub-menu${openMenus["profess"] ? "open" : ""}`} id="sub-sub-nav">
                <li><a href="#">Physical Design-Part Time</a></li>
                <li><a href="#">ASIC Verification-Part Time</a></li>
                <li><a href="#">Analog Layout Design-Part Time</a></li>
                <li><a href="#">Design For Test-Part Time</a></li>
                <li><a href="#">Analog Circuit Design</a></li>
                <li><a href="#">RTL Coding and FPGA Design-Part Time</a></li>
                <li><a href="#">FINFET Layout Design Training</a></li>
                <li><a href="#">UVM Training</a></li>
                <li><a href="#">PERL Scripting</a></li>
                </ul>
              </li>
              <li className="has-submenu">
                <span>Online Courses</span>
                <i
                  className={`bi toggle-dropdown ${
                    openMenus["online"] ? "bi-chevron-up" : "bi-chevron-down"
                  }`}
                  onClick={() => toggleSubMenu("online")}
                ></i>
                <ul className={`sub-menu ${openMenus["online"] ? "open" : ""}`} id="sub-sub-nav">
                <li><a href="#">Physical Design Online</a></li>
                <li><a href="#">ASIC Verification Online</a></li>
                <li><a href="#">Analog Layout Design Online</a></li>
                <li><a href="#">Design For Test Online</a></li>
                <li><a href="#">Analog Circuit Design Online</a></li>
                <li><a href="#">RTL Coding and FPGA Design Online</a></li>
                <li><a href="#">UVM Training Online</a></li>
                </ul>
              </li>

              <li><a href='#'>Online Course Videos</a></li>
              <li><a href='#'>Free Demo Class</a></li>
              <li><a href='#'>1-Day Free VLSI Training</a></li>
            </ul>
          </li>

          <li id="main-nav"><a href="#">Course Calendar</a></li>
          <li id="main-nav"><a href="#">Corporate</a></li>
          <li id="main-nav"><a href="#">VLSI Internship</a></li>
          <li id="main-nav"><a href='#'>Academic</a></li>
          <li id="main-nav"><a href='#'>Placements</a></li>
          <li id="main-nav"><a href='#'>Contact</a></li>
          <li id="main-nav"><a href='#'>Blog</a></li>

         

        </ul>
      </nav>

      {isOpen && <div className="overlay" onClick={toggleMenu}></div>}
    </div>
  );
};

export default Mobile;
